module.exports = __webpack_public_path__ + "img/gsw.72f21392.gif";